var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c("div", { staticClass: "content customer-label" }, [
        _c("div", { staticClass: "content-box" }, [
          _c(
            "div",
            { staticClass: "content-box-right" },
            [_c("graphic-content")],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content group-detail" }, [
      _c("h2", { staticClass: "title_class" }, [_vm._v("客户分群")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }